import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatus = () => {
  const [systemHealth, setSystemHealth] = useState({
    googleApi: 'online',
    ldapSync: 'online',
    database: 'online',
    lastUpdate: new Date()
  });

  useEffect(() => {
    // Simulate system health check
    const checkSystemHealth = () => {
      setSystemHealth(prev => ({
        ...prev,
        lastUpdate: new Date()
      }));
    };

    const interval = setInterval(checkSystemHealth, 30000); // Check every 30 seconds
    return () => clearInterval(interval);
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'online': return 'text-success';
      case 'warning': return 'text-warning';
      case 'offline': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'online': return 'CheckCircle';
      case 'warning': return 'AlertTriangle';
      case 'offline': return 'XCircle';
      default: return 'Circle';
    }
  };

  const statusItems = [
    { key: 'googleApi', label: 'Google API', status: systemHealth?.googleApi },
    { key: 'ldapSync', label: 'LDAP Sync', status: systemHealth?.ldapSync },
    { key: 'database', label: 'Datenbank', status: systemHealth?.database }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-medium text-foreground">Systemstatus</h3>
        <span className="text-xs text-muted-foreground">
          Aktualisiert: {systemHealth?.lastUpdate?.toLocaleTimeString('de-DE')}
        </span>
      </div>
      <div className="space-y-2">
        {statusItems?.map((item) => (
          <div key={item?.key} className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">{item?.label}</span>
            <div className="flex items-center space-x-1">
              <Icon 
                name={getStatusIcon(item?.status)} 
                size={14} 
                className={getStatusColor(item?.status)} 
              />
              <span className={`text-xs font-medium ${getStatusColor(item?.status)}`}>
                {item?.status === 'online' ? 'Online' : 
                 item?.status === 'warning' ? 'Warnung' : 'Offline'}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 pt-3 border-t border-border">
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span className="text-xs text-muted-foreground">
            Alle Systeme betriebsbereit
          </span>
        </div>
      </div>
    </div>
  );
};

export default SystemStatus;